<template>
  <ClientOnly>
    <header class="gr-appbar">
      <div class="gr-appbar__inner">
        <NuxtLink
          :to="HOME_ROUTE"
          class="gr-appbar__brand"
          aria-label="Gotong Royong Indonesia, ke beranda"
        >
          <img
            src="/logo-gotong-royong-indonesia.webp"
            alt="Gotong Royong Indonesia Logo"
            width="168"
            height="50"
            class="gr-appbar__logo"
          />
        </NuxtLink>

        <nav class="gr-appbar__nav" aria-label="Navigasi utama">
          <ul class="gr-appbar__list">
            <li>
              <a
                :href="HOME_ROUTE"
                class="gr-appbar__link"
                @click.prevent="navigateToSection(HOME_ROUTE, 'home')"
              >
                Beranda
              </a>
            </li>
            <li>
              <a
                :href="`${HOME_ROUTE}#tentang-kami`"
                class="gr-appbar__link"
                @click.prevent="navigateToSection(HOME_ROUTE, 'tentang-kami')"
              >
                Tentang kami
              </a>
            </li>
            <li>
              <a
                :href="`${HOME_ROUTE}#kelebihan-kami`"
                class="gr-appbar__link"
                @click.prevent="navigateToSection(HOME_ROUTE, 'kelebihan-kami')"
              >
                Kelebihan kami
              </a>
            </li>
            <li>
              <NuxtLink class="gr-appbar__link" to="/activities">
                Cari aktivitas
              </NuxtLink>
            </li>
            <li>
              <NuxtLink
                class="gr-appbar__link"
                to="/activities?status=FINISHED"
              >
                Jejak Aktivitas
              </NuxtLink>
            </li>
            <li>
              <NuxtLink class="gr-appbar__link" to="/documentation">
                Dokumentasi Kegiatan
              </NuxtLink>
            </li>
          </ul>
        </nav>

        <div class="gr-appbar__actions">
          <template v-if="!$auth.isAuthenticated">
            <NuxtLink
              to="/auth?type=signup"
              class="gr-btn gr-btn--outline gr-appbar__btn"
            >
              Daftar
            </NuxtLink>
            <NuxtLink to="/auth" class="gr-btn gr-btn--solid gr-appbar__btn">
              Masuk
            </NuxtLink>
          </template>
          <UserProfileMenuButton v-else @logout="onLogout" />

          <button
            type="button"
            class="gr-appbar__menu-btn"
            aria-label="Menu navigasi"
            :aria-expanded="isShowDrawer"
            @click.stop="onToggleDrawer"
          >
            <v-icon icon="mdi-menu" size="24" aria-hidden="true" />
          </button>
        </div>
      </div>
    </header>

    <v-navigation-drawer
      v-model="isShowDrawer"
      temporary
      location="right"
      width="300"
      class="gr-drawer"
    >
      <v-list class="px-3">
        <v-list-subheader class="gr-drawer__subheader">
          Tentang Platform
        </v-list-subheader>
        <v-list-item
          @click="navigateSidebarToSection(HOME_ROUTE, 'tentang-kami')"
        >
          <v-list-item-title>Tentang kami</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="navigateSidebarToSection(HOME_ROUTE, 'kelebihan-kami')"
        >
          <v-list-item-title>Kelebihan kami</v-list-item-title>
        </v-list-item>
        <v-list-item to="/activities" @click="isShowDrawer = false">
          <v-list-item-title>Cari aktivitas</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/activities?status=FINISHED"
          @click="isShowDrawer = false"
        >
          <v-list-item-title>Jejak Aktivitas</v-list-item-title>
        </v-list-item>
        <v-list-item to="/documentation" @click="isShowDrawer = false">
          <v-list-item-title>Dokumentasi Kegiatan</v-list-item-title>
        </v-list-item>
        <v-divider class="my-2" />

        <template v-if="$auth.isAuthenticated">
          <template v-if="$auth.isSuperAdmin">
            <v-list-subheader class="gr-drawer__subheader">
              Manajemen
            </v-list-subheader>
            <v-list-item
              to="/dashboard/admin/users"
              @click="isShowDrawer = false"
            >
              <v-list-item-title>Kelola Pengguna</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboard/admin/activities"
              @click="isShowDrawer = false"
            >
              <v-list-item-title>Kelola Aktivitas</v-list-item-title>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-subheader class="gr-drawer__subheader">
              Akun Pengguna
            </v-list-subheader>
            <v-list-item to="/dashboard/profile" @click="isShowDrawer = false">
              <v-list-item-title>Profil</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboard/my-activities"
              @click="isShowDrawer = false"
            >
              <v-list-item-title>Aktivitas saya</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboard/activities"
              @click="isShowDrawer = false"
            >
              <v-list-item-title>Kelola aktivitas</v-list-item-title>
            </v-list-item>
          </template>
          <v-divider class="my-2" />
          <v-list-subheader class="gr-drawer__subheader">
            Pengaturan
          </v-list-subheader>
          <v-list-item
            to="/dashboard/change-password"
            @click="isShowDrawer = false"
          >
            <v-list-item-title>Ganti kata sandi</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>

      <template #append>
        <div class="pa-3">
          <NuxtLink
            v-if="!$auth.isAuthenticated"
            to="/auth"
            class="gr-btn gr-btn--solid gr-drawer__cta"
            @click="isShowDrawer = false"
          >
            Masuk / Daftar
          </NuxtLink>
          <button
            v-else
            type="button"
            class="gr-btn gr-btn--solid gr-drawer__cta"
            @click="onLogout"
          >
            <v-icon icon="mdi-logout" size="18" aria-hidden="true" />
            Keluar
          </button>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- SSR fallback: the same masthead without the authentication-dependent
         half, matching the canonical AppBar's ClientOnly pattern. -->
    <template #fallback>
      <header class="gr-appbar">
        <div class="gr-appbar__inner">
          <NuxtLink
            :to="HOME_ROUTE"
            class="gr-appbar__brand"
            aria-label="Gotong Royong Indonesia, ke beranda"
          >
            <img
              src="/logo-gotong-royong-indonesia.webp"
              alt="Gotong Royong Indonesia Logo"
              width="168"
              height="50"
              class="gr-appbar__logo"
            />
          </NuxtLink>
          <div class="gr-appbar__actions">
            <NuxtLink
              to="/auth?type=signup"
              class="gr-btn gr-btn--outline gr-appbar__btn"
            >
              Daftar
            </NuxtLink>
            <NuxtLink to="/auth" class="gr-btn gr-btn--solid gr-appbar__btn">
              Masuk
            </NuxtLink>
          </div>
        </div>
      </header>
    </template>
  </ClientOnly>
</template>

<script lang="ts" setup>
import { useDisplay } from "vuetify";
import { useAnchorScroll } from "~/common/composables/useAnchorScroll";
import UserProfileMenuButton from "@/layouts/components/UserProfileMenuButton.vue";

// Home has a candidate variant, so in-page anchors stay inside the experiment.
// Every other destination keeps its canonical route.
const HOME_ROUTE = "/";

const { navigateToSection } = useAnchorScroll();
const { lgAndUp } = useDisplay();

const isShowDrawer = ref(false);

const onToggleDrawer = (): void => {
  isShowDrawer.value = !isShowDrawer.value;
};

const navigateSidebarToSection = (path: string, section: string): void => {
  navigateToSection(path, section);
  isShowDrawer.value = false;
};

// The inline nav appears at lg and up, so the drawer must close there.
watchEffect(() => {
  if (lgAndUp.value) isShowDrawer.value = false;
});

const { $auth } = useNuxtApp();

const onLogout = (): void => {
  $auth.signOut();
  isShowDrawer.value = false;
};
</script>

<style scoped>
.gr-appbar {
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--gr-line);
  background-color: rgba(250, 249, 245, 0.94);
  backdrop-filter: saturate(1.4) blur(6px);
}

.gr-appbar__inner {
  display: flex;
  align-items: center;
  gap: 32px;
  /* Full viewport width with edge gutters, not the 1200px content container:
     seven destinations plus the brand and two actions do not fit inside the
     content measure without crowding. */
  min-height: 72px;
  padding-inline: clamp(1rem, 0.5rem + 2vw, 2rem);
}

.gr-appbar__brand {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  min-height: 44px;
}

.gr-appbar__logo {
  display: block;
  width: 168px;
  height: 50px;
  /* A plain <img> defaults to object-fit: fill and the asset is 180x60, so
     without this it stretches. */
  object-fit: contain;
}

.gr-appbar__nav {
  display: none;
  flex: 1 1 auto;
  min-width: 0;
}

.gr-appbar__list {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.gr-appbar__link {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding-inline: 10px;
  color: var(--gr-ink);
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: -0.005em;
  line-height: 1.2;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.gr-appbar__link::after {
  position: absolute;
  right: 10px;
  bottom: 14px;
  left: 10px;
  height: 2px;
  background-color: var(--gr-green-deep);
  content: "";
  opacity: 0;
  transform: scaleX(0.4);
  transition:
    opacity 120ms cubic-bezier(0.2, 0, 0, 1),
    transform 120ms cubic-bezier(0.2, 0, 0, 1);
}

@media (hover: hover) {
  .gr-appbar__link:hover {
    color: var(--gr-green-deep);
  }

  .gr-appbar__link:hover::after {
    opacity: 1;
    transform: scaleX(1);
  }
}

.gr-appbar__link:focus-visible::after {
  opacity: 0;
}

.gr-appbar__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.gr-appbar__btn {
  min-height: 40px;
  padding-inline: 16px;
  font-size: 0.875rem;
}

.gr-appbar__menu-btn {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--gr-line-strong);
  border-radius: 4px;
  background: transparent;
  color: var(--gr-ink);
  cursor: pointer;
}

/* Seven inline destinations need room; below this the drawer carries them. */
@media (min-width: 1280px) {
  .gr-appbar__nav {
    display: block;
  }

  .gr-appbar__menu-btn {
    display: none;
  }
}

/* Brand, both authentication actions and the menu button have to share one
   row here, so the masthead tightens rather than dropping any of them. */
@media (max-width: 560px) {
  .gr-appbar__inner {
    gap: 8px;
    padding-inline: 12px;
  }

  .gr-appbar__logo {
    width: 120px;
    height: 36px;
  }

  .gr-appbar__actions {
    gap: 6px;
  }

  .gr-appbar__btn {
    min-height: 40px;
    padding-inline: 10px;
    font-size: 0.8125rem;
  }
}

@media (max-width: 380px) {
  .gr-appbar__logo {
    width: 104px;
    height: 32px;
  }

  .gr-appbar__btn {
    padding-inline: 8px;
    font-size: 0.75rem;
  }
}

/* Below this the row cannot hold four items side by side; the brand steps down
   to its mark and the actions wrap under it. */
@media (max-width: 320px) {
  .gr-appbar__inner {
    flex-wrap: wrap;
    padding-block: 8px;
  }

  .gr-appbar__brand {
    flex: 1 1 100%;
  }

  .gr-appbar__actions {
    flex: 1 1 100%;
    margin-left: 0;
  }

  .gr-appbar__btn {
    flex: 1 1 auto;
  }
}

.gr-drawer__subheader {
  color: var(--gr-ink-3) !important;
  font-size: 0.6875rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.gr-drawer :deep(.v-list-item-title) {
  color: var(--gr-ink-2);
  font-size: 0.9375rem;
  font-weight: 500;
}

.gr-drawer :deep(.v-list-item) {
  min-height: 48px;
  border-radius: 4px;
}

.gr-drawer__cta {
  width: 100%;
}
</style>
